// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ISelectedConfiguration,
  ISingleCampaign,
  ICreatedConfigurationConfigData,
  ICampaignConfigFieldData,
  SpecialCampaignData
} from '@app/core/models/core-models';
import { UrlAddressConfigService } from '@services/url-address-config/url-address-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ProgramConfiguration } from '@services/url-address-config/url-address-config.types';
import { IBannerConfigData } from '@app/core/services/banners/banners.service.types';
import { SelectContainerChosenValue } from '@app/shared/components/select-container/select-container.component';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';
import { NotificationTypes } from '@app/core/services/global-notifications/global-notifications.model';

@Component({
  selector: 'app-configuration-created',
  templateUrl: './configuration-created.component.html',
  styleUrls: ['./configuration-created.component.scss']
})
export class ConfigurationCreatedComponent implements OnInit {
  @Input() currentCampaign?: ISingleCampaign | SpecialCampaignData;
  @Input() selectedConfigData?: ISelectedConfiguration;
  @Input() configurationData?: IBannerConfigData;
  @Input() component?: string;
  @Input() isSuccessfullySubmitted = false;
  @Input() noWayBack = false;
  @Output() backToBannersList = new EventEmitter<boolean>();
  @Output() emitConfiguration = new EventEmitter<ICreatedConfigurationConfigData>();

  public submitted = false;
  public trackingDomains: ICampaignConfigFieldData = { values: [], system_name: 'domain' };
  public configurationInfoTitle: string = '';
  public idOfDefaultValue = 0;
  public selectData: {
    title: string;
    data: {
      id: number;
      name: string;
    }[];
  } = {
    title: 'tracking_domain',
    data: []
  };
  public modalLoading = true;
  private selectedDomain = 0;
  private config?: ProgramConfiguration;

  public get isBannerComponent(): boolean {
    return this.component === 'banners';
  }

  constructor(
    private globalNotificationsService: GlobalNotificationsService,
    private configService: UrlAddressConfigService,
    public activeModal: NgbActiveModal,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    if (this.isBannerComponent) {
      this.configurationInfoTitle = `${this.translate.instant('view_translations.configuration_for_banner')} "${this.selectedConfigData?.width || 0}x${
        this.selectedConfigData?.height || 0
      }" ${this.translate.instant('view_translations.has_been_added')}`;
    } else {
      this.configurationInfoTitle = `${this.translate.instant('view_translations.configuration_for_product')} "${
        this.selectedConfigData?.name || ''
      }" ${this.translate.instant('view_translations.has_been_added')}`;
    }
  }

  public getPickedConfig(element: ProgramConfiguration): void {
    this.config = element;
    this.getProgramDomains();
  }

  public getSelectedValue(value: SelectContainerChosenValue): void {
    this.selectedDomain = value.choosenValue.id;
    this.idOfDefaultValue = ((this.trackingDomains.values as Record<string, string | number>[]) || [])?.findIndex(
      domain => domain.id === value.choosenValue.id
    );
  }

  public moveBack(): void {
    // Setting this paramter to false turns off banner configuration
    this.backToBannersList.emit(false);
  }

  public actionButton(): void {
    if (this.isSuccessfullySubmitted) {
      this.activeModal.close();
    } else {
      this.verify();
    }
  }

  private getProgramDomains(): void {
    this.modalLoading = true;
    this.configService.getProgramDomains(this.currentCampaign?.id || 0, this.config?.id || 0, 'banners').subscribe(res => {
      this.trackingDomains.values = (res.data?.domains || []).map(domain => ({ ...domain, value: domain.domain || '' }));
      this.selectData.data = [];
      this.trackingDomains.system_name = 'domain';

      this.trackingDomains.values.map(trackingDomain => {
        this.selectData.data.push({
          id: (trackingDomain.id as number) || 0,
          name: (trackingDomain.domain as string) || ''
        });
      });

      const firstItem = this.trackingDomains.values?.[0]?.id;

      this.selectedDomain = typeof firstItem === 'string' ? Number(firstItem) : typeof firstItem === 'number' ? firstItem : 0;
      this.modalLoading = false;
    });
  }

  private verify(): void {
    this.submitted = true;

    if (!this.config?.id || !this.selectedDomain) {
      this.showNotification('missing_domain_or_id', NotificationTypes[1]);
      return;
    }
    if (this.noWayBack) {
      // todo: send also something like this, data required for code generation without creation, or inject configurationData to modal
      this.configurationData = {
        bannerConfigID: this.selectedConfigData?.configuration_id,
        domainID: this.selectedDomain,
        programID: this.currentCampaign?.id || 0
      };
      this.isSuccessfullySubmitted = true;
    } else {
      this.emitConfiguration.next({
        config: this.config,
        trackingDomain: { id: this.selectedDomain }
      });
    }
  }

  private showNotification(message: string, type: (typeof NotificationTypes)[number], translate: boolean = true): void {
    this.globalNotificationsService.show({
      message: translate && !message.includes('view_translations.') ? `view_translations.${message}` : message,
      type,
      translate,
      isPersistent: false,
      id: ''
    });
  }
}
